import { Dialog, Flex, useLocalStorage } from '@buffer-mono/popcorn'

import { DeviceType, getAppLink } from '../../utils'

import { AppStoreBadge, GooglePlayBadge } from './AppStoreBadges'
import styles from './DownloadAppModal.module.css'

import type { JSX } from 'react'

type DownloadAppModalProps = {
  closeAction: () => void
}

const DownloadAppContent = ({
  closeAction,
}: DownloadAppModalProps): JSX.Element => {
  return (
    <Flex justify="center" direction="column" align="center" gap="lg">
      <Dialog.Body>
        <Flex justify="center" direction="column" align="center" gap="xs">
          <Dialog.Title className={styles.heading}>
            Welcome to Buffer 👋
          </Dialog.Title>
          <Dialog.Description align="center" className={styles.description}>
            By the way, you can also use our mobile app for a smoother
            experience.
          </Dialog.Description>
        </Flex>
        <Flex justify="between" gap="md" fullWidth>
          <GooglePlayBadge
            href={getAppLink(DeviceType.Android)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeAction}
          />
          <AppStoreBadge
            href={getAppLink(DeviceType.IOS)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeAction}
          />
        </Flex>
      </Dialog.Body>
    </Flex>
  )
}

const DownloadAppModal = ({
  closeAction,
}: DownloadAppModalProps): JSX.Element | null => {
  const [, setPromoteDownloadAppModal] = useLocalStorage(
    'promoteDownloadAppModal',
    true,
  )

  const isNewSettings = window.location.pathname.includes('settings/')

  if (isNewSettings) {
    return null
  }

  const handleClose = (): void => {
    setPromoteDownloadAppModal(false)
    closeAction()
  }

  return (
    <Dialog open={true} onOpenChange={handleClose}>
      <Dialog.Content className={styles.wrapper}>
        <DownloadAppContent closeAction={handleClose} />
        <Dialog.CloseButton className={styles.closeButton} />
      </Dialog.Content>
    </Dialog>
  )
}

export default DownloadAppModal
